import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	Button,
	Col,
	Divider,
	Form,
	message,
	Row,
	Typography,
	Upload,
} from 'antd';
import InputComponent from '../../../../component/InputComponent';
import { accommodationRequest } from '../../../../request/AuthRequest';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { observer } from 'mobx-react';
const { Title } = Typography;

const RoomCategoryImageUpload = observer((props) => {
	const {
		handleChange,
		onFinish,
		id,
		form,
		fileLists,
		setFileLists,
		initialValues,
		viewMode,
		disabledDefault
	} = props;
	const { AUTH, ACCOMMODATION } = useStore();

	const validateFile = (file) => {
		const isCorrectFile = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/jfif', 'video/mp4', 'video/quicktime', 'video/x-msvideo'].includes(
			file.type
		);
		const isLt25M = file.size / 1024 / 1024 < 25;
		if (!isCorrectFile) {
			message.error(`${file.name} is not a valid IMAGE or VIDEO file`);
		}
		if (!isLt25M) {
			message.error('IMAGE or VIDEO file must be smaller than 25MB!');
		}
		return isCorrectFile && isLt25M;
	};

	const beforeUpload = (file, fieldName) => {
		if (validateFile(file)) {
			setFileLists((prev) => ({
				...prev,
				[fieldName]: [file], // Set the file for the current field
			}));
			return false; // Prevent automatic upload
		}
		return false; // Prevent automatic upload
	};

	// Handle file removal
	const handleRemove = (fieldName) => {
		const updated = { ...fileLists };
		delete updated[fieldName];
		const reIndexed = Object.keys(updated).reduce((acc, key, idx) => {
			acc[idx] = updated[key];
			return acc;
		}, {});
		setFileLists(reIndexed);
		handleChange();
	};

	return (
		<div>
			<Form
				id={id}
				layout="vertical"
				form={form}
				onFinish={onFinish}
				autoComplete="off"
				onChange={handleChange}
				initialValues={initialValues}
				disabled={viewMode}
			>
				<Row gutter={24}>
					{!form.getFieldValue('roomCategoryImageList') &&
					viewMode ? (
						<Title level={3}>{Message().noRecord}</Title>
					) : (
						<Col span={24}>
							<Col span={6}>
								<InputComponent
									required
									type="select"
									showSearch={true}
									name="RoomCategoryId"
									label="Select Room Category Type"
									placeholder="Select Room Category Type"
									onChange={handleChange}
									options={{
										values: ACCOMMODATION.roomCategoryLookup,
										value_key: 'eRoomCategoryId',
										text_key: 'roomTitle',
									}}
									rules={
										accommodationRequest.roomCategoryLookup
									}
								/>
							</Col>
							{form.getFieldValue('RoomCategoryId') && (
								<Form.List name="roomCategoryImageList">
									{(fields, { add, remove }) => {
										return (
											<Row>
												{fields.map(
													({
														key,
														name,
														...restField
													}) => (
														<Col
															span={24}
															key={key}
														>
															<Row
																gutter={24}
																align={'bottom'}
															>
																<Col span={6}>
																	<InputComponent
																		required
																		type="select"
																		showSearch={
																			true
																		}
																		name={[
																			name,
																			'ImageType',
																		]}
																		label="Select Image or Video Type"
																		placeholder="Select Image or Video Type"
																		onChange={
																			handleChange
																		}
																		options={{
																			rejected_keys:
																				(disabledDefault && disabledDefault === 3) && form.getFieldValue('roomCategoryImageList')[name]?.ImageType !== 3 ? [3] : [],
																			values: AUTH.lookupKeyList,
																			value_key:
																				'lookupIntValue',
																			text_key:
																				'lookupValue',
																		}}
																		rules={
																			accommodationRequest.imageType
																		}
																	/>
																</Col>
																<Col span={8}>
																	<InputComponent
																		required
																		name={[
																			name,
																			'Description',
																		]}
																		label="Image or Video Description"
																		placeholder="Enter Image or Video Description"
																		onChange={
																			handleChange
																		}
																		rules={
																			accommodationRequest.imgDescription
																		}
																	/>
																</Col>
																<Col span={6}>
																	<Form.Item
																		{...restField}
																		label={
																			'Select Image or Video'
																		}
																		required
																	>
																		<Form.Item
																			{...restField}
																			name={[
																				name,
																				'fileList',
																			]}
																			noStyle
																		>
																			<Upload
																				onChange={
																					handleChange
																				}
																				name="file"
																				multiple={
																					false
																				}
																				accept={
																					'image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/jfif', 'video/mp4', 'video/quicktime'
																				}
																				listType="picture"
																				beforeUpload={(
																					file
																				) =>
																					beforeUpload(
																						file,
																						name
																					)
																				}
																				onRemove={() =>
																					handleRemove(
																						name
																					)
																				}
																				fileList={
																					fileLists[
																						name
																					] ||
																					[]
																				}
																				showUploadList={{
																					showRemoveIcon: false,
																				}}
																			>
																				{!fileLists[
																					name
																				] ||
																				fileLists[
																					name
																				]
																					.length ===
																					0 ? (
																					<Button
																						icon={
																							<FontAwesomeIcon
																								icon={
																									faPlus
																								}
																							/>
																						}
																					>
																						Upload
																					</Button>
																				) : null}
																			</Upload>
																		</Form.Item>
																	</Form.Item>
																</Col>
																<Col span={4}>
																	<Button
																		danger
																		style={{
																			marginBottom:
																				'12px',
																		}}
																		onClick={async (
																			e
																		) => {
																			let curruntRoomCategoryImageDetails =
																				ACCOMMODATION.roomCategoryImageDetails.find(
																					(
																						_x,
																						index
																					) =>
																						index ===
																						name
																				);
																			if (
																				curruntRoomCategoryImageDetails
																			) {
																				await AUTH.onRemoveImage(
																					curruntRoomCategoryImageDetails.id,
																					curruntRoomCategoryImageDetails.versionNo
																				).then(
																					(
																						data
																					) => {
																						let tempStateData =
																							{
																								...fileLists,
																							};
																						delete tempStateData[
																							name
																						];
																						const reIndexedData =
																							Object.keys(
																								tempStateData
																							)
																								.map(
																									(
																										key
																									) =>
																										tempStateData[
																											key
																										]
																								)
																								.reduce(
																									(
																										acc,
																										value,
																										index
																									) => {
																										acc[
																											index
																										] =
																											value;
																										return acc;
																									},
																									{}
																								);
																						setFileLists(
																							reIndexedData
																						);
																						ACCOMMODATION.roomCategoryImageDetails =
																							ACCOMMODATION.roomCategoryImageDetails.filter(
																								(
																									_x,
																									index
																								) =>
																									index !==
																									name
																							);
																						if (
																							typeof data ===
																							'string'
																						) {
																							remove(
																								name
																							);
																						}
																					}
																				);
																			} else {
																				remove(
																					name
																				);
																				handleRemove(
																					name
																				);
																			}

																			handleChange();
																		}}
																	>
																		<FontAwesomeIcon
																			icon={
																				faMinus
																			}
																		/>
																	</Button>
																</Col>
															</Row>
														</Col>
													)
												)}
												{!viewMode && (
													<Divider align="center">
														<Form.Item
															style={{
																marginBottom:
																	'0',
															}}
														>
															<Button
																type="primary"
																onClick={() => {
																	add();
																	handleChange();
																}}
																icon={
																	<FontAwesomeIcon
																		icon={
																			faPlus
																		}
																	/>
																}
															>
																Add Image Detail
															</Button>
														</Form.Item>
													</Divider>
												)}
											</Row>
										);
									}}
								</Form.List>
							)}
						</Col>
					)}
				</Row>
			</Form>
		</div>
	);
});

export default RoomCategoryImageUpload;
